<section class="change-password-page">
  <div class="change-password-card">
    <div class="heading">
      <h1>Change Password</h1>
      <p>Update your password to keep your account secure.</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()" class="password-form">
      <label>
        <span>Current password</span>
        <input type="password" formControlName="current_password" placeholder="Current password">
      </label>

      <label>
        <span>New password</span>
        <input type="password" formControlName="new_password" placeholder="New password">
      </label>

      <p class="rules">{{ newPasswordHint }}</p>

      <label>
        <span>Confirm new password</span>
        <input type="password" formControlName="confirm_password" placeholder="Confirm new password">
      </label>

      @if (form.errors?.['passwordMismatch'] && form.touched) {
        <p class="error-message">New password and confirm password must match.</p>
      }

      @if (form.controls.new_password.errors?.['passwordPolicy'] && form.controls.new_password.touched) {
        <p class="error-message">Password must include one capital letter except O, one small letter except o, one number, and be at least 8 characters long.</p>
      }

      @if (message) {
        <p class="error-message">{{ message }}</p>
      }

      @if (successMessage) {
        <p class="success-message">{{ successMessage }}</p>
      }

      <div class="actions">
        <a routerLink="/dashboard" class="secondary-button">Cancel</a>
        <button type="submit" class="primary-button" [disabled]="form.invalid">Change Password</button>
      </div>
    </form>
  </div>
</section>
